import { useEffect, useState } from 'react';
import financeService from '../../../services/financeService';
import { SelectOption } from '../../common/SearchableSelect';

const CASH_IN_HAND = /^111\d$/;

/** The tills that can be counted (cash-in-hand accounts) and whether a difference needs a second person. */
export const useCashCountSetup = () => {
  const [tills, setTills] = useState<SelectOption[]>([]);
  const [requiresApproval, setRequiresApproval] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let live = true;
    Promise.all([financeService.getCashBank({ page: 1, limit: 1 }), financeService.getApprovalRule()])
      .then(([bank, rule]) => {
        if (!live) return;
        setTills(bank.accounts.filter(a => CASH_IN_HAND.test(a.code)).map(a => ({ value: a._id, label: `${a.code} · ${a.name}` })));
        setRequiresApproval(rule.secondPerson);
      })
      .catch((e: any) => { if (live) setError(e?.message || 'Could not load the tills.'); });
    return () => { live = false; };
  }, []);

  return { tills, requiresApproval, error };
};
